import React from 'react'
import styled from '@emotion/styled'
import { withAttrs } from '../../utils'
import Link from '../shared/link'
import useGalleryNavigation from './hooks/use-gallery-nav'

const Nav = styled.nav`
  padding: ${p => p.theme.space[2]} 0;
`

const SubgroupLink = styled(withAttrs(Link, { activeClassName: 'active' }))`
  position: relative;
  display: flex;
  justify-content: space-between;
  padding: ${p => `${p.theme.space[3]} ${p.theme.space[6]}`};
  font-size: ${p => p.theme.fontSizes[1]};
  color: ${p => p.theme.colors.text};
  &:hover,
  &.active {
    background: ${p => p.theme.colors.gray[1]};
  }
`

const TemplateCount = styled.span`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: 20px;
`

const SubgroupMenu = ({ className, group }) => {
  const { createPath } = useGalleryNavigation()
  return (
    <Nav className={className}>
      {group.subgroups.map(subgroup => (
        <SubgroupLink
          key={subgroup.name}
          to={createPath(group.name, subgroup.name)}
          state={{ noScroll: true }}
        >
          {subgroup.name}
          <TemplateCount>{subgroup.templateCount}</TemplateCount>
        </SubgroupLink>
      ))}
    </Nav>
  )
}

export default SubgroupMenu
